import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../animations/page-transitions';
import { DatacenterNumericFilter, DynamicDatacenterFilter } from '../../../models/datacenter-filters';
import {
	DatacenterFilterValidationService
} from '../../../services/datacenter-filter-validation.service';

@Component({
	selector: 'copo-numeric-filter',
	templateUrl: './view-numeric-filter.component.html',
	styleUrl: './view-numeric-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		TranslateModule,
		MatButtonModule,
	]
})
export class ViewNumericFilterComponent implements DynamicDatacenterFilter<DatacenterNumericFilter> {
	@Input() filter?: DatacenterNumericFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;

	isValid: boolean[] = [];

	constructor(private readonly filterValidationService: DatacenterFilterValidationService) {}

	removeValue(index: number) {
		if (!this.filter) {
			return;
		}

		this.filter.getValues().splice(index, 1);
		this.isValid.splice(index, 1);
		if (this.isValid.every(Boolean)) {
			this.filterValidationService.removeInvalidField(this.filter.filterId);
		}

		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues().filter(filterValue => filterValue.to || filterValue.from)
			};
		}
		return undefined;
	}

	checkValidationFrom(event: string, index: number) {
		if (this.filter === undefined) {
			return;
		}
		this.filter.getValues()[index].from = event.replace(/,/g, '.');
		this.checkValidation(index);
	}

	checkValidationTo(event: string, index: number) {
		if (this.filter === undefined) {
			return;
		}
		this.filter.getValues()[index].to = event.replace(/,/g, '.');
		this.checkValidation(index);
	}

	checkValidation(index: number) {
		if (this.filter === undefined) {
			return;
		}
		this.isValid[index] = this.filter.isValidFilter(
			this.filter.getValues()[index].from,
			this.filter.getValues()[index].to
		);
		if (this.isValid.every(Boolean)) {
			this.filterValidationService.removeInvalidField(this.filter.filterId);
		} else {
			this.filterValidationService.setInvalidField(this.filter.filterId);
		}
	}
}
